import React from 'react'
import { transformRegionToMap } from 'msp-integrations'
import ProductSpecs from '@molecules/ProductSpecs/ProductSpecs'
import { getProductSpecs } from './ProductSpecsWrapper.utils'
import { ProductSpecsImage } from './ProductSpecsWrapper.types'

const ProductSpecsWrapper = ({
  custom,
  data,
  product,
  regions
}: {
  custom: any
  data: any
  product: any
  regions: any
}) => {
  const {
    leftContent,
    leftHeadline,
    leftImageAlt,
    leftImageShadow,
    rightContent,
    rightHeadline,
    rightImageAlt,
    rightImageShadow
  } = data

  const customLeftImage: ProductSpecsImage = {
    url: custom?.content?.leftImage?.path || '',
    name: leftImageAlt || leftHeadline || '',
    showShadow: leftImageShadow
  }

  const customRightImage: ProductSpecsImage = {
    url: custom?.content?.rightImage?.path || '',
    name: rightImageAlt || rightHeadline || '',
    showShadow: rightImageShadow
  }

  const productSpec = getProductSpecs(product)

  const productSpecsLinks =
    transformRegionToMap(regions).get('productSpecsLinks')

  return product && data ? (
    <ProductSpecs
      product={productSpec}
      leftHeadline={leftHeadline}
      leftContent={leftContent}
      leftImage={customLeftImage}
      rightHeadline={rightHeadline}
      rightContent={rightContent}
      rightImage={customRightImage}
      links={productSpecsLinks}
    />
  ) : (
    <></>
  )
}

export default ProductSpecsWrapper
